export default [
  {
    name: 'data-integrations',
    path: '/settings/data-integrations',
    component: () => import(/* webpackChunkName: "data-integrations" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Integrações de Dados',
      icon: 'mdi-sync',
      label: 'Integrações de Dados',
      roles: ['Admin']
    }
  },
  {
    name: 'data-integration-form',
    path: '/settings/data-integrations/form/:id',
    component: () => import(/* webpackChunkName: "data-integrations" */ './Form.vue'),
    meta: {
      showNavbar: true,
      title: 'Integração de Dados',
      icon: 'mdi-sync',
      label: 'Integração de Dados',
      roles: ['Admin']
    }
  },
  {
    name: 'data-integration-provider',
    path: '/settings/data-integrations/:provider',
    component: () => import(/* webpackChunkName: "data-integrations" */ './ProviderIntegrations.vue'),
    meta: {
      showNavbar: true,
      title: 'Integrações',
      icon: 'mdi-sync',
      label: 'Integrações',
      roles: ['Admin']
    }
  }
]
